import '../../App.css'
import { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid'
import { SelectGenericFromTable } from '../universal/Axios';
import { GetPerformancePercentile } from '../universal/InternalCalculator';
import { CustomToolbar } from '../universal/GridHelper';

const GenAlgGenerationTable = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("id")
    const [genAlgGenerationResultsData, setGenAlgGenerationResultsData] = useState(undefined);

    useEffect(() => {
        SelectGenericFromTable("select gag.*, nb.average_si_sdr, nb.median_si_sdr from gen_alg_generation gag join network_batch nb on gag.network_batch_id = nb.id where gen_alg_run_id = '" + id + "' order by generation_number desc;", setGenAlgGenerationResultsData)
    }, []);

    const genAlgGenerationResultsColumns = [
        {
            field: 'id',
            headerName: 'Gen Alg Generation ID',
            width: 440,
            renderCell: (params) => (
                <>
                    <a
                        href={'edit-gen-alg-generation?id=' + params.row.id}
                    >
                        {params.row.id}
                    </a>
                </>
            ),
        },
        {
            field: 'generation_number',
            headerName: 'Number',
            width: 100,
        },
        {
            field: 'network_batch_id',
            headerName: 'Network Batch ID',
            width: 840,
            renderCell: (params) => (
                <>
                    <a
                        href={'edit-network-batch?id=' + params.row.network_batch_id}
                        target="_blank"
                    >
                        {params.row.network_batch_id}
                    </a>
                </>
            ),
        }, 
        {
            field: 'median_si_sdr',
            headerName: 'Median SI-SDR',
            width: 160,
            renderCell: (params) => (
                params.value != null ?
                    <span style={{ color: 'rgb(' + ((1 - parseFloat(params.row.relative_median_si_sdr)) * 255) + ',' + (parseFloat(params.row.relative_median_si_sdr) * 255) + ',0)' }}
                    >
                        {params.value.toString()}
                    </span> : <span></span>
            ),
        },
        {
            field: 'average_si_sdr',
            headerName: 'Mean SI-SDR',
            width: 160,
            renderCell: (params) => (
                params.value != null ?
                    <span style={{ color: 'rgb(' + ((1 - parseFloat(params.row.relative_average_si_sdr)) * 255) + ',' + (parseFloat(params.row.relative_average_si_sdr) * 255) + ',0)' }}
                    >
                        {params.value.toString()}
                    </span> : <span></span>
            ),
        },
        {
            field: 'description',
            headerName: 'Description',
            width: 140,
        },
        {
            field: 'created_date',
            headerName: 'Created Date',
            width: 160
        }
    ];

    let genAlgGenerationResultsDataRows = genAlgGenerationResultsData?.filter(data => data != null).map((genAlgGenerationResults) =>
    ({   
        id: genAlgGenerationResults.id,
        generation_number: genAlgGenerationResults.generation_number,
        network_batch_id: genAlgGenerationResults.network_batch_id,
        average_si_sdr: genAlgGenerationResults.average_si_sdr,
        median_si_sdr: genAlgGenerationResults.median_si_sdr,
        description: genAlgGenerationResults.description,
        created_date: genAlgGenerationResults.created_date
    }))

    useEffect(() => {
        if (genAlgGenerationResultsDataRows !== undefined) {
            genAlgGenerationResultsDataRows = GetPerformancePercentile(genAlgGenerationResultsDataRows, 'average_si_sdr', 'relative_average_si_sdr', 0);
            genAlgGenerationResultsDataRows = GetPerformancePercentile(genAlgGenerationResultsDataRows, 'median_si_sdr', 'relative_median_si_sdr', 0);
        }

    }, [genAlgGenerationResultsDataRows])


    if (genAlgGenerationResultsData === undefined) {
        return (<p>loading...</p>)
    }
    return (
        <DataGrid
            disableSelectionOnClick
            rows={genAlgGenerationResultsDataRows}
            columns={genAlgGenerationResultsColumns}
            pagination={true}
            initialState={{
              sorting: {
                    sortModel: [{ field: 'generation_number', sort: 'asc' }],
              },
            }}
            components={{
                Toolbar: () => CustomToolbar("Gen_Alg_Generation_" + id),
            }}
      />
    )
};

export { GenAlgGenerationTable };
